import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
  carouselRoot: {
    padding: 5,
    '& > .CarouselItem': {
      padding: 5,
    },
  },
  paperRoot: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  descriptionWrapper: {
    '&:hover': {
      textDecoration: 'underline',
    },
    padding: 5,
    position: 'absolute',
    top: 250,
  },
}));

export default useStyles;
